import { faInbox } from "@fortawesome/pro-regular-svg-icons";
import { useTranslation } from "react-i18next";
import EmptyState from "@components/shared/elements/empty-state";

// Shared empty state for the asset filter panel (bookmarks / popular /
// most-viewed / recently-changed). "all" never reaches this — the menu shows
// the asset tree for that case — so one filter-agnostic message is correct.
export const FilterEmpty = () => {
  const { t } = useTranslation();

  return (
    <EmptyState
      data-testid="filter-empty"
      size="small"
      icon={faInbox}
      title={t("assets.filterEmpty")}
      sx={{ px: 2 }}
    />
  );
};
